import RemoveButton from "@/components/RemoveButton";
import { MainWrapper } from "@/lib/styles";
import styled from "styled-components";

export const Container = styled(MainWrapper)<{ $filtersActive: boolean }>`
  display: flex;
  gap: 1rem;
  padding: ${({ $filtersActive }) =>  $filtersActive ? "1.5rem 0" : "0"};
  flex-wrap: wrap;
`;

export const Button = styled(RemoveButton)`
  &.item-enter {
    opacity: 0;
  }
  &.item-enter-active {
    opacity: 1;
    transition: opacity 200ms ease-in;
  }
  &.item-exit {
    opacity: 1;
  }
  &.item-exit-active {
    opacity: 0;
    transition: opacity 200ms ease-in;
  }
`;
